import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	ITEM: '[data-fragment="AccordionComponent.item"]',
	LINK: '[data-fragment="AccordionComponent.link"]',
};

class AccordionComponent extends WebComponent {
	constructor(props) {
		super(props);
		const {
			show = false,
		} = props;
		this.state = {
			show,
		};
	}
	didMount() {
		this.on('click',fragments.LINK, this.handleClickOnLink);
		this.itemElement = this.element.querySelectorAll(fragments.ITEM);
	}


	handleClickOnLink = (e) => {
		const {
			show,
		} = this.state;

		this.setState({
			show: !show,
		});
		let isOpen = e.closestTarget.offsetParent.classList.contains('accordion__item--active');
		for(let i = 0; i < this.itemElement.length; i++) {
			let content = this.itemElement[i];
			classNames(content, {'accordion__item--active': false});
		}

		if(!isOpen) {
			classNames(e.closestTarget.offsetParent, {'accordion__item--active': true,});
		} else {
			classNames(e.closestTarget.offsetParent, {'accordion__item--active': false,});
		}

		var elementOffsetTop = e.closestTarget.offsetParent.getBoundingClientRect().top + window.pageYOffset;
		window.scroll({
			top: elementOffsetTop, // could be negative value
			left: 0,
			behavior: 'smooth'
		});

	}

	willUnMount() {
		this.itemElement = null;
	}
	update(prevProps, prevState, inDocument) {
		const {
			show,
		} = this.state;

		classNames(this.element, {
			'back-to-top--show': show,
		});
	}
}

export default AccordionComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/AccordionComponent/AccordionComponent.js